import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootSaga from '../Sagas';
import login from './login'
import user from './user'
import certificates from './certificates'
import gestionXml from './gestionXml'
import _genericComponents from './_GenericComponents';
import captcha from './captcha';
import license from './license';
import packages from './gestionPackages';
import paymentTransaction from './paymentTransaction';
import taxpayer from './taxpayer';
import statusService from './statusService';
import notification from './notification';
import { PURGE } from 'redux-persist';
import schedule from './schedule';
import dashboard from './dashboard';
import folders from './folders';
import googleDrive from './googleDrive';
import register from './register';
import responseRate from './responseRate';

const appReducer = combineReducers({
	login,
	user,
	certificates,
	gestionXml,
	_genericComponents,
	captcha,
	license,
	packages,
	paymentTransaction,
	taxpayer,
	statusService,
	notification,
	schedule,
	dashboard,
	folders,
	googleDrive,
	register,
	responseRate
});

const rootReducer = (state, action) => {
	if (action.type === PURGE) {
		state = undefined
	}
	return appReducer(state,action);
}

const initialState = {};

//SAGAS CONFIG
const sagaMiddleware = createSagaMiddleware();
/*
  Descomentar la linea del enhancers para usar el plugin de redux en chrome
*/
const enhancers = [
	//window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()  
];
const middleware = [
	sagaMiddleware,
];

const composedEnhancers = compose(
	applyMiddleware(...middleware),
	...enhancers,
);

const persistConfig = {
	key: 'root',
	storage,
	blacklist: ['_genericComponents', 'captcha', 'packages']
}

const persistedReducer = persistReducer(persistConfig, rootReducer);
let store = createStore(persistedReducer, initialState, composedEnhancers)
let persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export { store, persistor };